"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSelect = void 0;

var _themeGet = require("@styled-system/theme-get");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("../../helpers");

var _utils = require("../../utils");

var _useUpdateEffect = require("../../utils/useUpdateEffect");

var _useWidthOf2 = require("../../utils/useWidthOf");

var _Box = require("../Box");

var _Checkbox = require("../Checkbox");

var _Clickable = require("../Clickable");

var _Select = require("../Select");

var _Sup = require("../Sup");

var _Text = require("../Text");

var _excluded = ["complete", "description", "disabled", "error", "focus", "hover", "name", "options", "required", "title", "onSelect"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MultiSelect = function MultiSelect(_ref) {
  var complete = _ref.complete,
      description = _ref.description,
      disabled = _ref.disabled,
      error = _ref.error,
      focus = _ref.focus,
      hover = _ref.hover,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "Select" : _ref$name,
      options = _ref.options,
      required = _ref.required,
      title = _ref.title,
      onSelect = _ref.onSelect,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      selection = _useState4[0],
      setSelection = _useState4[1]; // Yields focus back and forth between popover and anchor


  (0, _useUpdateEffect.useUpdateEffect)(function () {
    if (visible && tooltipRef.current) {
      tooltipRef.current.focus();
      return;
    }

    if (!anchorRef.current) return;
    anchorRef.current.focus();
  }, [visible]);

  var onVisible = function onVisible() {
    return setVisible(true);
  };

  var onHide = function onHide() {
    return setVisible(false);
  };

  (0, _react.useEffect)(function () {
    var handleKeydown = function handleKeydown(event) {
      if (event.key === "Escape") {
        onHide();
      }
    };

    document.addEventListener("keydown", handleKeydown);
    return function () {
      document.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  var _usePosition = (0, _utils.usePosition)({
    position: "bottom",
    offset: 10,
    active: visible
  }),
      anchorRef = _usePosition.anchorRef,
      tooltipRef = _usePosition.tooltipRef;

  var _useWidthOf = (0, _useWidthOf2.useWidthOf)({
    ref: anchorRef
  }),
      width = _useWidthOf.width;

  (0, _utils.useClickOutside)({
    ref: tooltipRef,
    onClickOutside: onHide,
    when: visible,
    type: "click"
  });

  var handleSelect = function handleSelect(option) {
    return function (selected) {
      var prevSelection = selection;
      var nextSelection = selected ? [].concat(_toConsumableArray(prevSelection), [option]) : prevSelection.filter(function (_ref2) {
        var value = _ref2.value;
        return option.value !== value;
      });
      setSelection(nextSelection);
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(nextSelection);
    };
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (title || description) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "xs"
  }, title, required && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    as: "span",
    color: "brand"
  }, "*")), description && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "xs",
    color: "black60"
  }, description)), /*#__PURE__*/_react.default.createElement(Container, _extends({
    ref: anchorRef,
    onClick: onVisible,
    complete: complete || selection.length > 0,
    disabled: disabled,
    error: error,
    focus: focus || visible,
    hover: hover,
    mt: title || description ? 0.5 : 0
  }, rest), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "sm",
    lineHeight: 1
  }, name, selection.length > 0 && /*#__PURE__*/_react.default.createElement(_Sup.Sup, {
    color: "brand"
  }, "\xA0", selection.length))), visible && /*#__PURE__*/_react.default.createElement(Options, {
    tabIndex: 0,
    ref: tooltipRef,
    zIndex: 1,
    bg: "white100",
    width: width
  }, options.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, {
      key: option.value,
      height: 50,
      px: 1,
      selected: selection.includes(option),
      onSelect: handleSelect(option)
    }, option.text);
  })), error && typeof error === "string" && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "xs",
    mt: 0.5,
    color: "red100"
  }, error));
};

exports.MultiSelect = MultiSelect;
var Options = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "MultiSelect__Options",
  componentId: "amrkn0-0"
})(["position:fixed;z-index:1;max-height:300px;text-align:left;box-shadow:", ";overflow-y:auto;-webkit-overflow-scrolling:touch;"], _helpers.DROP_SHADOW);
var STATES = {
  default: (0, _styledComponents.css)(["color:", ";border-color:", ";"], (0, _themeGet.themeGet)("colors.black60"), (0, _themeGet.themeGet)("colors.black30")),
  complete: (0, _styledComponents.css)(["color:", ";border-color:", ";"], (0, _themeGet.themeGet)("colors.black100"), (0, _themeGet.themeGet)("colors.black60")),
  focus: (0, _styledComponents.css)(["color:", ";border-color:", ";"], (0, _themeGet.themeGet)("colors.black100"), (0, _themeGet.themeGet)("colors.black60")),
  hover: (0, _styledComponents.css)(["color:", ";border-color:", ";"], (0, _themeGet.themeGet)("colors.black100"), (0, _themeGet.themeGet)("colors.black60")),
  disabled: (0, _styledComponents.css)(["color:", ";border-color:", ";"], (0, _themeGet.themeGet)("colors.black30"), (0, _themeGet.themeGet)("colors.black30")),
  error: (0, _styledComponents.css)(["color:", ";border-color:", ";"], (0, _themeGet.themeGet)("colors.black100"), (0, _themeGet.themeGet)("colors.red100"))
};
var Container = (0, _styledComponents.default)(_Clickable.Clickable).withConfig({
  displayName: "MultiSelect__Container",
  componentId: "amrkn0-1"
})(["position:relative;width:100%;height:50px;border:0;border-bottom:1px solid;padding:0 24px 0 ", ";transition:background-color 0.25s,border-color 0.25s;", " ", ""], (0, _themeGet.themeGet)("space.1"), function (props) {
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", " ", " &:hover{", "}&:focus{", "}&:disabled{cursor:default;", "}"], STATES.default, props.complete && STATES.complete, props.hover && STATES.hover, props.focus && STATES.focus, props.disabled && STATES.disabled, props.error && STATES.error, STATES.hover, STATES.focus, STATES.disabled);
}, _Select.caretMixin);
//# sourceMappingURL=MultiSelect.js.map